// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".notes-button[data-v-7dfc3168]{cursor:pointer;background-color:#000;color:#fff;font-weight:700;text-transform:uppercase;display:flex;justify-content:center;align-items:center;width:48px;height:48px}.notes-button.mobile[data-v-7dfc3168]{margin-left:auto}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
